// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: interface.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { AnalysisTreeGenerationRules_NodeInheritanceRules, AnalysisTreeProto } from "./analysis";
import {
  AnalysisStepProto,
  KGObservationDataProto,
  KGObservationProto,
  RecommendationProto,
  SelectionCriteriaProto,
} from "./analysis_plan";
import {
  ColumnType,
  columnTypeFromJSON,
  columnTypeToJSON,
  HeaderStatus,
  headerStatusFromJSON,
  headerStatusToJSON,
  MetadataTypeEnum,
  metadataTypeEnumFromJSON,
  metadataTypeEnumToJSON,
} from "./enums";
import { BenchmarkProto, ErrorDetailProto, FilterProto, Header, MetricProto } from "./metadata";
import {
  ScheduledJobProto,
  ScheduledJobRunProto,
  ScheduledJobType,
  scheduledJobTypeFromJSON,
  scheduledJobTypeToJSON,
} from "./schedule";

export const protobufPackage = "com.meritic.newton";

/**
 * API to create/update metrics on a data model.
 * @Path: /metric/create
 * @Method: POST
 * @Consumes: application/json
 */
export interface CreateOrUpdateMetrics {
}

export interface CreateOrUpdateMetrics_Request {
  /**
   * Id of the data model on which metrics are created.
   * This is required only till we add ownerId to header.
   * After that, columns inside the metric should belong to the same owner.
   */
  model_id?:
    | string
    | undefined;
  /**
   * If metric header has id, then the metric is updated, else it is created.
   * For update operation, the metric name and description are not updated,
   * only the output columns are updated.
   */
  metrics: MetricProto[];
  /**
   * Flag to indicate if the MKG edges should be updated or not.
   * This is only valid for update request. Create will always create the requested edges.
   * If update_edges=false, then edges in the metric proto are ignored and old edges are returned.
   * Default value is false.
   */
  update_edges?: boolean | undefined;
}

export interface CreateOrUpdateMetrics_Response {
  metrics: MetricProto[];
}

/**
 * API Request Proto to register users
 * @Path: /user/register
 * @Method: POST, UPDATE
 * @Consumes: application/json
 */
export interface UserRequestProto {
  /** name of the user */
  name?:
    | string
    | undefined;
  /** email of the user */
  email?:
    | string
    | undefined;
  /** password of the user */
  password?:
    | string
    | undefined;
  /** if the user is admin or not */
  is_admin?: boolean | undefined;
}

/**
 * API Request Proto to update user
 * @Path: /user/update
 * @Method: PUT
 * @Consumes: application/json
 */
export interface UserProto {
  /** Header containing user metadata (id, name, etc.) */
  header?:
    | Header
    | undefined;
  /** email of the user */
  email?:
    | string
    | undefined;
  /** if the user is admin or not */
  is_admin?:
    | boolean
    | undefined;
  /** JSON string for client-specific data (e.g. default_analyst_id) */
  client_object_json?: string | undefined;
}

/**
 * API to fetch AnalysisTree and Commentary
 * @Path: /analysisTree/generate
 * @Method: POST
 * @Consumes: application/json
 */
export interface GenerateAnalysisTree {
}

export interface GenerateAnalysisTree_Request {
  /** Id of the metric for which analysis Tree will be generated. */
  metricId?:
    | string
    | undefined;
  /** Name for the analysis tree that is generated. */
  tree_name?:
    | string
    | undefined;
  /** Benchmark for the analysis. */
  benchmark: BenchmarkProto[];
  /** List of context filters. */
  context: FilterProto[];
  /** List of mkg edges to exclude while generating analysis tree. */
  exclude_edges: Header[];
  /** Parameters to indicate when to switch to diagnostic analysis during tree generation. */
  diagnostic_plan?: AnalysisTreeGenerationRules_NodeInheritanceRules | undefined;
}

export interface GenerateAnalysisTree_Response {
  /** tree generated for the given metric and context */
  tree?: AnalysisTreeProto | undefined;
}

/** Represents sorting that should be applied on metadata headers. */
export interface SortingParams {
  /** Sorting field. */
  sort_by?:
    | SortingParams_SortField
    | undefined;
  /** True for sorting in ascending order, false otherwise. Default is false (desc). */
  sort_asc?: boolean | undefined;
}

/** Represents the header field on which sorting should be applied. */
export enum SortingParams_SortField {
  LAST_MODIFIED = 0,
  CREATED = 1,
  NAME = 2,
  UNRECOGNIZED = -1,
}

export function sortingParams_SortFieldFromJSON(object: any): SortingParams_SortField {
  switch (object) {
    case 0:
    case "LAST_MODIFIED":
      return SortingParams_SortField.LAST_MODIFIED;
    case 1:
    case "CREATED":
      return SortingParams_SortField.CREATED;
    case 2:
    case "NAME":
      return SortingParams_SortField.NAME;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SortingParams_SortField.UNRECOGNIZED;
  }
}

export function sortingParams_SortFieldToJSON(object: SortingParams_SortField): string {
  switch (object) {
    case SortingParams_SortField.LAST_MODIFIED:
      return "LAST_MODIFIED";
    case SortingParams_SortField.CREATED:
      return "CREATED";
    case SortingParams_SortField.NAME:
      return "NAME";
    case SortingParams_SortField.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Represents pagination parameters for the list of metadata headers. */
export interface PaginationParams {
  /** Max number of headers in the response. */
  page_size?:
    | number
    | undefined;
  /**
   * Page number to retrieve.
   * Pagination offset = (pageNumber - 1) * pageSize
   */
  page_number?: number | undefined;
}

/** Parameters to filter the headers during search. */
export interface SearchFilterParams {
  /** Type of metadata entity for which headers should be fetched. */
  metadata_type?:
    | MetadataTypeEnum
    | undefined;
  /**
   * Filter metadata entities with the given status.
   * For analysis trees, this represents whether tree is in draft or not.
   * By default, isDraft=false.
   */
  header_status?:
    | HeaderStatus
    | undefined;
  /**
   * Filter entities with the given owner id.
   * For analysis trees, this represents the metric for which tree was run.
   */
  owner_ids: string[];
  /** Filter headers with name/description containing the given string. */
  search_string?:
    | string
    | undefined;
  /**
   * Filters headers by the author.
   * For admin users, they may want to see entities created by a particular user.
   */
  author_id?:
    | string
    | undefined;
  /** Filter on the metadata content. */
  content_filter?:
    | SearchFilterParams_ContentFilter
    | undefined;
  /** Ids of the metrics. */
  metric_ids: string[];
  /** Active Schedule */
  active_schedule?:
    | boolean
    | undefined;
  /** Type of scheduled job for which headers should be fetched. */
  job_type?:
    | ScheduledJobType
    | undefined;
  /** Include all metadata within the given list of ids. */
  metadata_ids: string[];
}

/** Filter on the content of metadata entities. */
export interface SearchFilterParams_ContentFilter {
  /** Show trees containing the given context. */
  context: FilterProto[];
}

/** Request response structures to generate Analysis Step name. */
export interface StepScribe {
}

export interface StepScribe_Request {
  root_step_id?: string | undefined;
  steps: AnalysisStepProto[];
}

export interface StepScribe_Response {
  step_name?: string | undefined;
  step_description?: string | undefined;
}

/** API to get dummy recommendation for the given kg observation and selection criteria. */
export interface GetRecommendations {
}

export interface GetRecommendations_Request {
  kg_observation?: KGObservationProto | undefined;
  selection_criteria?: SelectionCriteriaProto | undefined;
}

export interface GetRecommendations_Response {
  recommendations: RecommendationProto[];
}

/** API to get the kg observation data for the given kg observation and analysis columns. */
export interface GetMKGObservationData {
}

export interface GetMKGObservationData_Request {
  request_id?: string | undefined;
  kg_observation?: KGObservationProto | undefined;
}

export interface GetMKGObservationData_Response {
  request_id?: string | undefined;
  kg_observation_data?: KGObservationDataProto | undefined;
  error_details: ErrorDetailProto[];
}

/**
 * Request structure for dependency.
 * @Path: /metadata/dependency
 * @Method: POST
 * @Consumes: application/json
 */
export interface DependencyRequestProto {
  ids: string[];
  metadata_type?: MetadataTypeEnum | undefined;
  dependent_types: MetadataTypeEnum[];
  ignore_definition_filters?: boolean | undefined;
}

/** Response structure for dependency. */
export interface DependencyProto {
  metadata_id?: string | undefined;
  metadata_type?: string | undefined;
  headers: Header[];
}

/** API to get the matching Kg-columns for the given name and column type. */
export interface GetKGMapping {
}

export interface GetKGMapping_Request {
  name?: string | undefined;
  columnType?: ColumnType | undefined;
}

export interface GetKGMapping_Response {
  name?: string | undefined;
  headers: Header[];
}

/** API to get the scheduled job run. */
export interface GetScheduledJobRun {
}

export interface GetScheduledJobRun_Request {
}

export interface GetScheduledJobRun_Response {
  job_run?: ScheduledJobRunProto | undefined;
  job?: ScheduledJobProto | undefined;
}

/** Analyst's stats returned in MetadataListResponse when include_stats=true. */
export interface AnalystStats {
  /** Metrics in the analyst's DataScope */
  num_metrics?:
    | number
    | undefined;
  /** Attribute KG columns scoped to this analyst */
  num_attributes?:
    | number
    | undefined;
  /** Temporal KG columns scoped to this analyst */
  num_timeframes?:
    | number
    | undefined;
  /** Benchmarks in the analyst's DataScope */
  num_benchmarks?:
    | number
    | undefined;
  /** Measure columns */
  num_measures?:
    | number
    | undefined;
  /** Scheduled jobs currently active (is_active=true) */
  num_live_jobs?:
    | number
    | undefined;
  /** Total scheduled jobs owned by this analyst */
  total_jobs?: number | undefined;
}

/** DataModel stats returned in MetadataListResponse when include_stats=true. */
export interface DataModelStats {
  /** Total logical columns in the model */
  total_logical_columns?:
    | number
    | undefined;
  /** Mapped attributes */
  num_mapped_attributes?:
    | number
    | undefined;
  /** Mapped measures */
  num_mapped_measures?:
    | number
    | undefined;
  /** Mapped timeframes */
  num_mapped_timeframes?:
    | number
    | undefined;
  /** Distinct metrics using this model's columns */
  num_mapped_metrics?: number | undefined;
}

function createBaseCreateOrUpdateMetrics(): CreateOrUpdateMetrics {
  return {};
}

export const CreateOrUpdateMetrics: MessageFns<CreateOrUpdateMetrics> = {
  encode(_: CreateOrUpdateMetrics, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateOrUpdateMetrics {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateOrUpdateMetrics();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): CreateOrUpdateMetrics {
    return {};
  },

  toJSON(_: CreateOrUpdateMetrics): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateOrUpdateMetrics>, I>>(base?: I): CreateOrUpdateMetrics {
    return CreateOrUpdateMetrics.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateOrUpdateMetrics>, I>>(_: I): CreateOrUpdateMetrics {
    const message = createBaseCreateOrUpdateMetrics();
    return message;
  },
};

function createBaseCreateOrUpdateMetrics_Request(): CreateOrUpdateMetrics_Request {
  return { model_id: undefined, metrics: [], update_edges: undefined };
}

export const CreateOrUpdateMetrics_Request: MessageFns<CreateOrUpdateMetrics_Request> = {
  encode(message: CreateOrUpdateMetrics_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.model_id !== undefined) {
      writer.uint32(10).string(message.model_id);
    }
    for (const v of message.metrics) {
      MetricProto.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.update_edges !== undefined) {
      writer.uint32(24).bool(message.update_edges);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateOrUpdateMetrics_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateOrUpdateMetrics_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.model_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.metrics.push(MetricProto.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.update_edges = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateOrUpdateMetrics_Request {
    return {
      model_id: isSet(object.model_id) ? globalThis.String(object.model_id) : undefined,
      metrics: globalThis.Array.isArray(object?.metrics) ? object.metrics.map((e: any) => MetricProto.fromJSON(e)) : [],
      update_edges: isSet(object.update_edges) ? globalThis.Boolean(object.update_edges) : undefined,
    };
  },

  toJSON(message: CreateOrUpdateMetrics_Request): unknown {
    const obj: any = {};
    if (message.model_id !== undefined) {
      obj.model_id = message.model_id;
    }
    if (message.metrics?.length) {
      obj.metrics = message.metrics.map((e) => MetricProto.toJSON(e));
    }
    if (message.update_edges !== undefined) {
      obj.update_edges = message.update_edges;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateOrUpdateMetrics_Request>, I>>(base?: I): CreateOrUpdateMetrics_Request {
    return CreateOrUpdateMetrics_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateOrUpdateMetrics_Request>, I>>(
    object: I,
  ): CreateOrUpdateMetrics_Request {
    const message = createBaseCreateOrUpdateMetrics_Request();
    message.model_id = object.model_id ?? undefined;
    message.metrics = object.metrics?.map((e) => MetricProto.fromPartial(e)) || [];
    message.update_edges = object.update_edges ?? undefined;
    return message;
  },
};

function createBaseCreateOrUpdateMetrics_Response(): CreateOrUpdateMetrics_Response {
  return { metrics: [] };
}

export const CreateOrUpdateMetrics_Response: MessageFns<CreateOrUpdateMetrics_Response> = {
  encode(message: CreateOrUpdateMetrics_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.metrics) {
      MetricProto.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateOrUpdateMetrics_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateOrUpdateMetrics_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metrics.push(MetricProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateOrUpdateMetrics_Response {
    return {
      metrics: globalThis.Array.isArray(object?.metrics) ? object.metrics.map((e: any) => MetricProto.fromJSON(e)) : [],
    };
  },

  toJSON(message: CreateOrUpdateMetrics_Response): unknown {
    const obj: any = {};
    if (message.metrics?.length) {
      obj.metrics = message.metrics.map((e) => MetricProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateOrUpdateMetrics_Response>, I>>(base?: I): CreateOrUpdateMetrics_Response {
    return CreateOrUpdateMetrics_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateOrUpdateMetrics_Response>, I>>(
    object: I,
  ): CreateOrUpdateMetrics_Response {
    const message = createBaseCreateOrUpdateMetrics_Response();
    message.metrics = object.metrics?.map((e) => MetricProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUserRequestProto(): UserRequestProto {
  return { name: undefined, email: undefined, password: undefined, is_admin: undefined };
}

export const UserRequestProto: MessageFns<UserRequestProto> = {
  encode(message: UserRequestProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.email !== undefined) {
      writer.uint32(18).string(message.email);
    }
    if (message.password !== undefined) {
      writer.uint32(26).string(message.password);
    }
    if (message.is_admin !== undefined) {
      writer.uint32(32).bool(message.is_admin);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserRequestProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserRequestProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.password = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.is_admin = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserRequestProto {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      email: isSet(object.email) ? globalThis.String(object.email) : undefined,
      password: isSet(object.password) ? globalThis.String(object.password) : undefined,
      is_admin: isSet(object.is_admin) ? globalThis.Boolean(object.is_admin) : undefined,
    };
  },

  toJSON(message: UserRequestProto): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.email !== undefined) {
      obj.email = message.email;
    }
    if (message.password !== undefined) {
      obj.password = message.password;
    }
    if (message.is_admin !== undefined) {
      obj.is_admin = message.is_admin;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserRequestProto>, I>>(base?: I): UserRequestProto {
    return UserRequestProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserRequestProto>, I>>(object: I): UserRequestProto {
    const message = createBaseUserRequestProto();
    message.name = object.name ?? undefined;
    message.email = object.email ?? undefined;
    message.password = object.password ?? undefined;
    message.is_admin = object.is_admin ?? undefined;
    return message;
  },
};

function createBaseUserProto(): UserProto {
  return { header: undefined, email: undefined, is_admin: undefined, client_object_json: undefined };
}

export const UserProto: MessageFns<UserProto> = {
  encode(message: UserProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.email !== undefined) {
      writer.uint32(18).string(message.email);
    }
    if (message.is_admin !== undefined) {
      writer.uint32(24).bool(message.is_admin);
    }
    if (message.client_object_json !== undefined) {
      writer.uint32(34).string(message.client_object_json);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.is_admin = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.client_object_json = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserProto {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      email: isSet(object.email) ? globalThis.String(object.email) : undefined,
      is_admin: isSet(object.is_admin) ? globalThis.Boolean(object.is_admin) : undefined,
      client_object_json: isSet(object.client_object_json) ? globalThis.String(object.client_object_json) : undefined,
    };
  },

  toJSON(message: UserProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.email !== undefined) {
      obj.email = message.email;
    }
    if (message.is_admin !== undefined) {
      obj.is_admin = message.is_admin;
    }
    if (message.client_object_json !== undefined) {
      obj.client_object_json = message.client_object_json;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserProto>, I>>(base?: I): UserProto {
    return UserProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserProto>, I>>(object: I): UserProto {
    const message = createBaseUserProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.email = object.email ?? undefined;
    message.is_admin = object.is_admin ?? undefined;
    message.client_object_json = object.client_object_json ?? undefined;
    return message;
  },
};

function createBaseGenerateAnalysisTree(): GenerateAnalysisTree {
  return {};
}

export const GenerateAnalysisTree: MessageFns<GenerateAnalysisTree> = {
  encode(_: GenerateAnalysisTree, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateAnalysisTree {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateAnalysisTree();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GenerateAnalysisTree {
    return {};
  },

  toJSON(_: GenerateAnalysisTree): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerateAnalysisTree>, I>>(base?: I): GenerateAnalysisTree {
    return GenerateAnalysisTree.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerateAnalysisTree>, I>>(_: I): GenerateAnalysisTree {
    const message = createBaseGenerateAnalysisTree();
    return message;
  },
};

function createBaseGenerateAnalysisTree_Request(): GenerateAnalysisTree_Request {
  return {
    metricId: undefined,
    tree_name: undefined,
    benchmark: [],
    context: [],
    exclude_edges: [],
    diagnostic_plan: undefined,
  };
}

export const GenerateAnalysisTree_Request: MessageFns<GenerateAnalysisTree_Request> = {
  encode(message: GenerateAnalysisTree_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metricId !== undefined) {
      writer.uint32(10).string(message.metricId);
    }
    if (message.tree_name !== undefined) {
      writer.uint32(18).string(message.tree_name);
    }
    for (const v of message.benchmark) {
      BenchmarkProto.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.context) {
      FilterProto.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.exclude_edges) {
      Header.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.diagnostic_plan !== undefined) {
      AnalysisTreeGenerationRules_NodeInheritanceRules.encode(message.diagnostic_plan, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateAnalysisTree_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateAnalysisTree_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tree_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.benchmark.push(BenchmarkProto.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.context.push(FilterProto.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.exclude_edges.push(Header.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.diagnostic_plan = AnalysisTreeGenerationRules_NodeInheritanceRules.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerateAnalysisTree_Request {
    return {
      metricId: isSet(object.metricId) ? globalThis.String(object.metricId) : undefined,
      tree_name: isSet(object.tree_name) ? globalThis.String(object.tree_name) : undefined,
      benchmark: globalThis.Array.isArray(object?.benchmark)
        ? object.benchmark.map((e: any) => BenchmarkProto.fromJSON(e))
        : [],
      context: globalThis.Array.isArray(object?.context) ? object.context.map((e: any) => FilterProto.fromJSON(e)) : [],
      exclude_edges: globalThis.Array.isArray(object?.exclude_edges)
        ? object.exclude_edges.map((e: any) => Header.fromJSON(e))
        : [],
      diagnostic_plan: isSet(object.diagnostic_plan)
        ? AnalysisTreeGenerationRules_NodeInheritanceRules.fromJSON(object.diagnostic_plan)
        : undefined,
    };
  },

  toJSON(message: GenerateAnalysisTree_Request): unknown {
    const obj: any = {};
    if (message.metricId !== undefined) {
      obj.metricId = message.metricId;
    }
    if (message.tree_name !== undefined) {
      obj.tree_name = message.tree_name;
    }
    if (message.benchmark?.length) {
      obj.benchmark = message.benchmark.map((e) => BenchmarkProto.toJSON(e));
    }
    if (message.context?.length) {
      obj.context = message.context.map((e) => FilterProto.toJSON(e));
    }
    if (message.exclude_edges?.length) {
      obj.exclude_edges = message.exclude_edges.map((e) => Header.toJSON(e));
    }
    if (message.diagnostic_plan !== undefined) {
      obj.diagnostic_plan = AnalysisTreeGenerationRules_NodeInheritanceRules.toJSON(message.diagnostic_plan);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerateAnalysisTree_Request>, I>>(base?: I): GenerateAnalysisTree_Request {
    return GenerateAnalysisTree_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerateAnalysisTree_Request>, I>>(object: I): GenerateAnalysisTree_Request {
    const message = createBaseGenerateAnalysisTree_Request();
    message.metricId = object.metricId ?? undefined;
    message.tree_name = object.tree_name ?? undefined;
    message.benchmark = object.benchmark?.map((e) => BenchmarkProto.fromPartial(e)) || [];
    message.context = object.context?.map((e) => FilterProto.fromPartial(e)) || [];
    message.exclude_edges = object.exclude_edges?.map((e) => Header.fromPartial(e)) || [];
    message.diagnostic_plan = (object.diagnostic_plan !== undefined && object.diagnostic_plan !== null)
      ? AnalysisTreeGenerationRules_NodeInheritanceRules.fromPartial(object.diagnostic_plan)
      : undefined;
    return message;
  },
};

function createBaseGenerateAnalysisTree_Response(): GenerateAnalysisTree_Response {
  return { tree: undefined };
}

export const GenerateAnalysisTree_Response: MessageFns<GenerateAnalysisTree_Response> = {
  encode(message: GenerateAnalysisTree_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tree !== undefined) {
      AnalysisTreeProto.encode(message.tree, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateAnalysisTree_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateAnalysisTree_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tree = AnalysisTreeProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerateAnalysisTree_Response {
    return { tree: isSet(object.tree) ? AnalysisTreeProto.fromJSON(object.tree) : undefined };
  },

  toJSON(message: GenerateAnalysisTree_Response): unknown {
    const obj: any = {};
    if (message.tree !== undefined) {
      obj.tree = AnalysisTreeProto.toJSON(message.tree);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerateAnalysisTree_Response>, I>>(base?: I): GenerateAnalysisTree_Response {
    return GenerateAnalysisTree_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerateAnalysisTree_Response>, I>>(
    object: I,
  ): GenerateAnalysisTree_Response {
    const message = createBaseGenerateAnalysisTree_Response();
    message.tree = (object.tree !== undefined && object.tree !== null)
      ? AnalysisTreeProto.fromPartial(object.tree)
      : undefined;
    return message;
  },
};

function createBaseSortingParams(): SortingParams {
  return { sort_by: undefined, sort_asc: undefined };
}

export const SortingParams: MessageFns<SortingParams> = {
  encode(message: SortingParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sort_by !== undefined) {
      writer.uint32(8).int32(message.sort_by);
    }
    if (message.sort_asc !== undefined) {
      writer.uint32(16).bool(message.sort_asc);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SortingParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSortingParams();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.sort_by = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.sort_asc = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SortingParams {
    return {
      sort_by: isSet(object.sort_by) ? sortingParams_SortFieldFromJSON(object.sort_by) : undefined,
      sort_asc: isSet(object.sort_asc) ? globalThis.Boolean(object.sort_asc) : undefined,
    };
  },

  toJSON(message: SortingParams): unknown {
    const obj: any = {};
    if (message.sort_by !== undefined) {
      obj.sort_by = sortingParams_SortFieldToJSON(message.sort_by);
    }
    if (message.sort_asc !== undefined) {
      obj.sort_asc = message.sort_asc;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SortingParams>, I>>(base?: I): SortingParams {
    return SortingParams.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SortingParams>, I>>(object: I): SortingParams {
    const message = createBaseSortingParams();
    message.sort_by = object.sort_by ?? undefined;
    message.sort_asc = object.sort_asc ?? undefined;
    return message;
  },
};

function createBasePaginationParams(): PaginationParams {
  return { page_size: undefined, page_number: undefined };
}

export const PaginationParams: MessageFns<PaginationParams> = {
  encode(message: PaginationParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.page_size !== undefined) {
      writer.uint32(8).int32(message.page_size);
    }
    if (message.page_number !== undefined) {
      writer.uint32(16).int32(message.page_number);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PaginationParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePaginationParams();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.page_size = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.page_number = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PaginationParams {
    return {
      page_size: isSet(object.page_size) ? globalThis.Number(object.page_size) : undefined,
      page_number: isSet(object.page_number) ? globalThis.Number(object.page_number) : undefined,
    };
  },

  toJSON(message: PaginationParams): unknown {
    const obj: any = {};
    if (message.page_size !== undefined) {
      obj.page_size = Math.round(message.page_size);
    }
    if (message.page_number !== undefined) {
      obj.page_number = Math.round(message.page_number);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PaginationParams>, I>>(base?: I): PaginationParams {
    return PaginationParams.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PaginationParams>, I>>(object: I): PaginationParams {
    const message = createBasePaginationParams();
    message.page_size = object.page_size ?? undefined;
    message.page_number = object.page_number ?? undefined;
    return message;
  },
};

function createBaseSearchFilterParams(): SearchFilterParams {
  return {
    metadata_type: undefined,
    header_status: undefined,
    owner_ids: [],
    search_string: undefined,
    author_id: undefined,
    content_filter: undefined,
    metric_ids: [],
    active_schedule: undefined,
    job_type: undefined,
    metadata_ids: [],
  };
}

export const SearchFilterParams: MessageFns<SearchFilterParams> = {
  encode(message: SearchFilterParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metadata_type !== undefined) {
      writer.uint32(8).int32(message.metadata_type);
    }
    if (message.header_status !== undefined) {
      writer.uint32(16).int32(message.header_status);
    }
    for (const v of message.owner_ids) {
      writer.uint32(26).string(v!);
    }
    if (message.search_string !== undefined) {
      writer.uint32(34).string(message.search_string);
    }
    if (message.author_id !== undefined) {
      writer.uint32(42).string(message.author_id);
    }
    if (message.content_filter !== undefined) {
      SearchFilterParams_ContentFilter.encode(message.content_filter, writer.uint32(50).fork()).join();
    }
    for (const v of message.metric_ids) {
      writer.uint32(58).string(v!);
    }
    if (message.active_schedule !== undefined) {
      writer.uint32(64).bool(message.active_schedule);
    }
    if (message.job_type !== undefined) {
      writer.uint32(72).int32(message.job_type);
    }
    for (const v of message.metadata_ids) {
      writer.uint32(82).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchFilterParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchFilterParams();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.metadata_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.header_status = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.owner_ids.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.search_string = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.author_id = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.content_filter = SearchFilterParams_ContentFilter.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metric_ids.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.active_schedule = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.job_type = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.metadata_ids.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchFilterParams {
    return {
      metadata_type: isSet(object.metadata_type) ? metadataTypeEnumFromJSON(object.metadata_type) : undefined,
      header_status: isSet(object.header_status) ? headerStatusFromJSON(object.header_status) : undefined,
      owner_ids: globalThis.Array.isArray(object?.owner_ids)
        ? object.owner_ids.map((e: any) => globalThis.String(e))
        : [],
      search_string: isSet(object.search_string) ? globalThis.String(object.search_string) : undefined,
      author_id: isSet(object.author_id) ? globalThis.String(object.author_id) : undefined,
      content_filter: isSet(object.content_filter)
        ? SearchFilterParams_ContentFilter.fromJSON(object.content_filter)
        : undefined,
      metric_ids: globalThis.Array.isArray(object?.metric_ids)
        ? object.metric_ids.map((e: any) => globalThis.String(e))
        : [],
      active_schedule: isSet(object.active_schedule) ? globalThis.Boolean(object.active_schedule) : undefined,
      job_type: isSet(object.job_type) ? scheduledJobTypeFromJSON(object.job_type) : undefined,
      metadata_ids: globalThis.Array.isArray(object?.metadata_ids)
        ? object.metadata_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: SearchFilterParams): unknown {
    const obj: any = {};
    if (message.metadata_type !== undefined) {
      obj.metadata_type = metadataTypeEnumToJSON(message.metadata_type);
    }
    if (message.header_status !== undefined) {
      obj.header_status = headerStatusToJSON(message.header_status);
    }
    if (message.owner_ids?.length) {
      obj.owner_ids = message.owner_ids;
    }
    if (message.search_string !== undefined) {
      obj.search_string = message.search_string;
    }
    if (message.author_id !== undefined) {
      obj.author_id = message.author_id;
    }
    if (message.content_filter !== undefined) {
      obj.content_filter = SearchFilterParams_ContentFilter.toJSON(message.content_filter);
    }
    if (message.metric_ids?.length) {
      obj.metric_ids = message.metric_ids;
    }
    if (message.active_schedule !== undefined) {
      obj.active_schedule = message.active_schedule;
    }
    if (message.job_type !== undefined) {
      obj.job_type = scheduledJobTypeToJSON(message.job_type);
    }
    if (message.metadata_ids?.length) {
      obj.metadata_ids = message.metadata_ids;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchFilterParams>, I>>(base?: I): SearchFilterParams {
    return SearchFilterParams.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchFilterParams>, I>>(object: I): SearchFilterParams {
    const message = createBaseSearchFilterParams();
    message.metadata_type = object.metadata_type ?? undefined;
    message.header_status = object.header_status ?? undefined;
    message.owner_ids = object.owner_ids?.map((e) => e) || [];
    message.search_string = object.search_string ?? undefined;
    message.author_id = object.author_id ?? undefined;
    message.content_filter = (object.content_filter !== undefined && object.content_filter !== null)
      ? SearchFilterParams_ContentFilter.fromPartial(object.content_filter)
      : undefined;
    message.metric_ids = object.metric_ids?.map((e) => e) || [];
    message.active_schedule = object.active_schedule ?? undefined;
    message.job_type = object.job_type ?? undefined;
    message.metadata_ids = object.metadata_ids?.map((e) => e) || [];
    return message;
  },
};

function createBaseSearchFilterParams_ContentFilter(): SearchFilterParams_ContentFilter {
  return { context: [] };
}

export const SearchFilterParams_ContentFilter: MessageFns<SearchFilterParams_ContentFilter> = {
  encode(message: SearchFilterParams_ContentFilter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.context) {
      FilterProto.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchFilterParams_ContentFilter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchFilterParams_ContentFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.context.push(FilterProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchFilterParams_ContentFilter {
    return {
      context: globalThis.Array.isArray(object?.context) ? object.context.map((e: any) => FilterProto.fromJSON(e)) : [],
    };
  },

  toJSON(message: SearchFilterParams_ContentFilter): unknown {
    const obj: any = {};
    if (message.context?.length) {
      obj.context = message.context.map((e) => FilterProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchFilterParams_ContentFilter>, I>>(
    base?: I,
  ): SearchFilterParams_ContentFilter {
    return SearchFilterParams_ContentFilter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchFilterParams_ContentFilter>, I>>(
    object: I,
  ): SearchFilterParams_ContentFilter {
    const message = createBaseSearchFilterParams_ContentFilter();
    message.context = object.context?.map((e) => FilterProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseStepScribe(): StepScribe {
  return {};
}

export const StepScribe: MessageFns<StepScribe> = {
  encode(_: StepScribe, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepScribe {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepScribe();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): StepScribe {
    return {};
  },

  toJSON(_: StepScribe): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<StepScribe>, I>>(base?: I): StepScribe {
    return StepScribe.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StepScribe>, I>>(_: I): StepScribe {
    const message = createBaseStepScribe();
    return message;
  },
};

function createBaseStepScribe_Request(): StepScribe_Request {
  return { root_step_id: undefined, steps: [] };
}

export const StepScribe_Request: MessageFns<StepScribe_Request> = {
  encode(message: StepScribe_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.root_step_id !== undefined) {
      writer.uint32(10).string(message.root_step_id);
    }
    for (const v of message.steps) {
      AnalysisStepProto.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepScribe_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepScribe_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.root_step_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.steps.push(AnalysisStepProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StepScribe_Request {
    return {
      root_step_id: isSet(object.root_step_id) ? globalThis.String(object.root_step_id) : undefined,
      steps: globalThis.Array.isArray(object?.steps) ? object.steps.map((e: any) => AnalysisStepProto.fromJSON(e)) : [],
    };
  },

  toJSON(message: StepScribe_Request): unknown {
    const obj: any = {};
    if (message.root_step_id !== undefined) {
      obj.root_step_id = message.root_step_id;
    }
    if (message.steps?.length) {
      obj.steps = message.steps.map((e) => AnalysisStepProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StepScribe_Request>, I>>(base?: I): StepScribe_Request {
    return StepScribe_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StepScribe_Request>, I>>(object: I): StepScribe_Request {
    const message = createBaseStepScribe_Request();
    message.root_step_id = object.root_step_id ?? undefined;
    message.steps = object.steps?.map((e) => AnalysisStepProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseStepScribe_Response(): StepScribe_Response {
  return { step_name: undefined, step_description: undefined };
}

export const StepScribe_Response: MessageFns<StepScribe_Response> = {
  encode(message: StepScribe_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.step_name !== undefined) {
      writer.uint32(10).string(message.step_name);
    }
    if (message.step_description !== undefined) {
      writer.uint32(18).string(message.step_description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepScribe_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepScribe_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.step_name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.step_description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StepScribe_Response {
    return {
      step_name: isSet(object.step_name) ? globalThis.String(object.step_name) : undefined,
      step_description: isSet(object.step_description) ? globalThis.String(object.step_description) : undefined,
    };
  },

  toJSON(message: StepScribe_Response): unknown {
    const obj: any = {};
    if (message.step_name !== undefined) {
      obj.step_name = message.step_name;
    }
    if (message.step_description !== undefined) {
      obj.step_description = message.step_description;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StepScribe_Response>, I>>(base?: I): StepScribe_Response {
    return StepScribe_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StepScribe_Response>, I>>(object: I): StepScribe_Response {
    const message = createBaseStepScribe_Response();
    message.step_name = object.step_name ?? undefined;
    message.step_description = object.step_description ?? undefined;
    return message;
  },
};

function createBaseGetRecommendations(): GetRecommendations {
  return {};
}

export const GetRecommendations: MessageFns<GetRecommendations> = {
  encode(_: GetRecommendations, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRecommendations {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRecommendations();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetRecommendations {
    return {};
  },

  toJSON(_: GetRecommendations): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetRecommendations>, I>>(base?: I): GetRecommendations {
    return GetRecommendations.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetRecommendations>, I>>(_: I): GetRecommendations {
    const message = createBaseGetRecommendations();
    return message;
  },
};

function createBaseGetRecommendations_Request(): GetRecommendations_Request {
  return { kg_observation: undefined, selection_criteria: undefined };
}

export const GetRecommendations_Request: MessageFns<GetRecommendations_Request> = {
  encode(message: GetRecommendations_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kg_observation !== undefined) {
      KGObservationProto.encode(message.kg_observation, writer.uint32(10).fork()).join();
    }
    if (message.selection_criteria !== undefined) {
      SelectionCriteriaProto.encode(message.selection_criteria, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRecommendations_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRecommendations_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.kg_observation = KGObservationProto.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.selection_criteria = SelectionCriteriaProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRecommendations_Request {
    return {
      kg_observation: isSet(object.kg_observation) ? KGObservationProto.fromJSON(object.kg_observation) : undefined,
      selection_criteria: isSet(object.selection_criteria)
        ? SelectionCriteriaProto.fromJSON(object.selection_criteria)
        : undefined,
    };
  },

  toJSON(message: GetRecommendations_Request): unknown {
    const obj: any = {};
    if (message.kg_observation !== undefined) {
      obj.kg_observation = KGObservationProto.toJSON(message.kg_observation);
    }
    if (message.selection_criteria !== undefined) {
      obj.selection_criteria = SelectionCriteriaProto.toJSON(message.selection_criteria);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetRecommendations_Request>, I>>(base?: I): GetRecommendations_Request {
    return GetRecommendations_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetRecommendations_Request>, I>>(object: I): GetRecommendations_Request {
    const message = createBaseGetRecommendations_Request();
    message.kg_observation = (object.kg_observation !== undefined && object.kg_observation !== null)
      ? KGObservationProto.fromPartial(object.kg_observation)
      : undefined;
    message.selection_criteria = (object.selection_criteria !== undefined && object.selection_criteria !== null)
      ? SelectionCriteriaProto.fromPartial(object.selection_criteria)
      : undefined;
    return message;
  },
};

function createBaseGetRecommendations_Response(): GetRecommendations_Response {
  return { recommendations: [] };
}

export const GetRecommendations_Response: MessageFns<GetRecommendations_Response> = {
  encode(message: GetRecommendations_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.recommendations) {
      RecommendationProto.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRecommendations_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRecommendations_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.recommendations.push(RecommendationProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRecommendations_Response {
    return {
      recommendations: globalThis.Array.isArray(object?.recommendations)
        ? object.recommendations.map((e: any) => RecommendationProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetRecommendations_Response): unknown {
    const obj: any = {};
    if (message.recommendations?.length) {
      obj.recommendations = message.recommendations.map((e) => RecommendationProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetRecommendations_Response>, I>>(base?: I): GetRecommendations_Response {
    return GetRecommendations_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetRecommendations_Response>, I>>(object: I): GetRecommendations_Response {
    const message = createBaseGetRecommendations_Response();
    message.recommendations = object.recommendations?.map((e) => RecommendationProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetMKGObservationData(): GetMKGObservationData {
  return {};
}

export const GetMKGObservationData: MessageFns<GetMKGObservationData> = {
  encode(_: GetMKGObservationData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMKGObservationData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMKGObservationData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetMKGObservationData {
    return {};
  },

  toJSON(_: GetMKGObservationData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMKGObservationData>, I>>(base?: I): GetMKGObservationData {
    return GetMKGObservationData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMKGObservationData>, I>>(_: I): GetMKGObservationData {
    const message = createBaseGetMKGObservationData();
    return message;
  },
};

function createBaseGetMKGObservationData_Request(): GetMKGObservationData_Request {
  return { request_id: undefined, kg_observation: undefined };
}

export const GetMKGObservationData_Request: MessageFns<GetMKGObservationData_Request> = {
  encode(message: GetMKGObservationData_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.request_id !== undefined) {
      writer.uint32(10).string(message.request_id);
    }
    if (message.kg_observation !== undefined) {
      KGObservationProto.encode(message.kg_observation, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMKGObservationData_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMKGObservationData_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.request_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.kg_observation = KGObservationProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMKGObservationData_Request {
    return {
      request_id: isSet(object.request_id) ? globalThis.String(object.request_id) : undefined,
      kg_observation: isSet(object.kg_observation) ? KGObservationProto.fromJSON(object.kg_observation) : undefined,
    };
  },

  toJSON(message: GetMKGObservationData_Request): unknown {
    const obj: any = {};
    if (message.request_id !== undefined) {
      obj.request_id = message.request_id;
    }
    if (message.kg_observation !== undefined) {
      obj.kg_observation = KGObservationProto.toJSON(message.kg_observation);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMKGObservationData_Request>, I>>(base?: I): GetMKGObservationData_Request {
    return GetMKGObservationData_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMKGObservationData_Request>, I>>(
    object: I,
  ): GetMKGObservationData_Request {
    const message = createBaseGetMKGObservationData_Request();
    message.request_id = object.request_id ?? undefined;
    message.kg_observation = (object.kg_observation !== undefined && object.kg_observation !== null)
      ? KGObservationProto.fromPartial(object.kg_observation)
      : undefined;
    return message;
  },
};

function createBaseGetMKGObservationData_Response(): GetMKGObservationData_Response {
  return { request_id: undefined, kg_observation_data: undefined, error_details: [] };
}

export const GetMKGObservationData_Response: MessageFns<GetMKGObservationData_Response> = {
  encode(message: GetMKGObservationData_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.request_id !== undefined) {
      writer.uint32(10).string(message.request_id);
    }
    if (message.kg_observation_data !== undefined) {
      KGObservationDataProto.encode(message.kg_observation_data, writer.uint32(18).fork()).join();
    }
    for (const v of message.error_details) {
      ErrorDetailProto.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMKGObservationData_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMKGObservationData_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.request_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.kg_observation_data = KGObservationDataProto.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.error_details.push(ErrorDetailProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMKGObservationData_Response {
    return {
      request_id: isSet(object.request_id) ? globalThis.String(object.request_id) : undefined,
      kg_observation_data: isSet(object.kg_observation_data)
        ? KGObservationDataProto.fromJSON(object.kg_observation_data)
        : undefined,
      error_details: globalThis.Array.isArray(object?.error_details)
        ? object.error_details.map((e: any) => ErrorDetailProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetMKGObservationData_Response): unknown {
    const obj: any = {};
    if (message.request_id !== undefined) {
      obj.request_id = message.request_id;
    }
    if (message.kg_observation_data !== undefined) {
      obj.kg_observation_data = KGObservationDataProto.toJSON(message.kg_observation_data);
    }
    if (message.error_details?.length) {
      obj.error_details = message.error_details.map((e) => ErrorDetailProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMKGObservationData_Response>, I>>(base?: I): GetMKGObservationData_Response {
    return GetMKGObservationData_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMKGObservationData_Response>, I>>(
    object: I,
  ): GetMKGObservationData_Response {
    const message = createBaseGetMKGObservationData_Response();
    message.request_id = object.request_id ?? undefined;
    message.kg_observation_data = (object.kg_observation_data !== undefined && object.kg_observation_data !== null)
      ? KGObservationDataProto.fromPartial(object.kg_observation_data)
      : undefined;
    message.error_details = object.error_details?.map((e) => ErrorDetailProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDependencyRequestProto(): DependencyRequestProto {
  return { ids: [], metadata_type: undefined, dependent_types: [], ignore_definition_filters: undefined };
}

export const DependencyRequestProto: MessageFns<DependencyRequestProto> = {
  encode(message: DependencyRequestProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.ids) {
      writer.uint32(10).string(v!);
    }
    if (message.metadata_type !== undefined) {
      writer.uint32(16).int32(message.metadata_type);
    }
    writer.uint32(26).fork();
    for (const v of message.dependent_types) {
      writer.int32(v);
    }
    writer.join();
    if (message.ignore_definition_filters !== undefined) {
      writer.uint32(32).bool(message.ignore_definition_filters);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DependencyRequestProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDependencyRequestProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ids.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.metadata_type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag === 24) {
            message.dependent_types.push(reader.int32() as any);

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.dependent_types.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.ignore_definition_filters = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DependencyRequestProto {
    return {
      ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e: any) => globalThis.String(e)) : [],
      metadata_type: isSet(object.metadata_type) ? metadataTypeEnumFromJSON(object.metadata_type) : undefined,
      dependent_types: globalThis.Array.isArray(object?.dependent_types)
        ? object.dependent_types.map((e: any) => metadataTypeEnumFromJSON(e))
        : [],
      ignore_definition_filters: isSet(object.ignore_definition_filters)
        ? globalThis.Boolean(object.ignore_definition_filters)
        : undefined,
    };
  },

  toJSON(message: DependencyRequestProto): unknown {
    const obj: any = {};
    if (message.ids?.length) {
      obj.ids = message.ids;
    }
    if (message.metadata_type !== undefined) {
      obj.metadata_type = metadataTypeEnumToJSON(message.metadata_type);
    }
    if (message.dependent_types?.length) {
      obj.dependent_types = message.dependent_types.map((e) => metadataTypeEnumToJSON(e));
    }
    if (message.ignore_definition_filters !== undefined) {
      obj.ignore_definition_filters = message.ignore_definition_filters;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DependencyRequestProto>, I>>(base?: I): DependencyRequestProto {
    return DependencyRequestProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DependencyRequestProto>, I>>(object: I): DependencyRequestProto {
    const message = createBaseDependencyRequestProto();
    message.ids = object.ids?.map((e) => e) || [];
    message.metadata_type = object.metadata_type ?? undefined;
    message.dependent_types = object.dependent_types?.map((e) => e) || [];
    message.ignore_definition_filters = object.ignore_definition_filters ?? undefined;
    return message;
  },
};

function createBaseDependencyProto(): DependencyProto {
  return { metadata_id: undefined, metadata_type: undefined, headers: [] };
}

export const DependencyProto: MessageFns<DependencyProto> = {
  encode(message: DependencyProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metadata_id !== undefined) {
      writer.uint32(10).string(message.metadata_id);
    }
    if (message.metadata_type !== undefined) {
      writer.uint32(18).string(message.metadata_type);
    }
    for (const v of message.headers) {
      Header.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DependencyProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDependencyProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.metadata_type = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.headers.push(Header.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DependencyProto {
    return {
      metadata_id: isSet(object.metadata_id) ? globalThis.String(object.metadata_id) : undefined,
      metadata_type: isSet(object.metadata_type) ? globalThis.String(object.metadata_type) : undefined,
      headers: globalThis.Array.isArray(object?.headers) ? object.headers.map((e: any) => Header.fromJSON(e)) : [],
    };
  },

  toJSON(message: DependencyProto): unknown {
    const obj: any = {};
    if (message.metadata_id !== undefined) {
      obj.metadata_id = message.metadata_id;
    }
    if (message.metadata_type !== undefined) {
      obj.metadata_type = message.metadata_type;
    }
    if (message.headers?.length) {
      obj.headers = message.headers.map((e) => Header.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DependencyProto>, I>>(base?: I): DependencyProto {
    return DependencyProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DependencyProto>, I>>(object: I): DependencyProto {
    const message = createBaseDependencyProto();
    message.metadata_id = object.metadata_id ?? undefined;
    message.metadata_type = object.metadata_type ?? undefined;
    message.headers = object.headers?.map((e) => Header.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetKGMapping(): GetKGMapping {
  return {};
}

export const GetKGMapping: MessageFns<GetKGMapping> = {
  encode(_: GetKGMapping, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetKGMapping {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetKGMapping();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetKGMapping {
    return {};
  },

  toJSON(_: GetKGMapping): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetKGMapping>, I>>(base?: I): GetKGMapping {
    return GetKGMapping.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetKGMapping>, I>>(_: I): GetKGMapping {
    const message = createBaseGetKGMapping();
    return message;
  },
};

function createBaseGetKGMapping_Request(): GetKGMapping_Request {
  return { name: undefined, columnType: undefined };
}

export const GetKGMapping_Request: MessageFns<GetKGMapping_Request> = {
  encode(message: GetKGMapping_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.columnType !== undefined) {
      writer.uint32(16).int32(message.columnType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetKGMapping_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetKGMapping_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.columnType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetKGMapping_Request {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      columnType: isSet(object.columnType) ? columnTypeFromJSON(object.columnType) : undefined,
    };
  },

  toJSON(message: GetKGMapping_Request): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.columnType !== undefined) {
      obj.columnType = columnTypeToJSON(message.columnType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetKGMapping_Request>, I>>(base?: I): GetKGMapping_Request {
    return GetKGMapping_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetKGMapping_Request>, I>>(object: I): GetKGMapping_Request {
    const message = createBaseGetKGMapping_Request();
    message.name = object.name ?? undefined;
    message.columnType = object.columnType ?? undefined;
    return message;
  },
};

function createBaseGetKGMapping_Response(): GetKGMapping_Response {
  return { name: undefined, headers: [] };
}

export const GetKGMapping_Response: MessageFns<GetKGMapping_Response> = {
  encode(message: GetKGMapping_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    for (const v of message.headers) {
      Header.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetKGMapping_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetKGMapping_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.headers.push(Header.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetKGMapping_Response {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      headers: globalThis.Array.isArray(object?.headers) ? object.headers.map((e: any) => Header.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetKGMapping_Response): unknown {
    const obj: any = {};
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.headers?.length) {
      obj.headers = message.headers.map((e) => Header.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetKGMapping_Response>, I>>(base?: I): GetKGMapping_Response {
    return GetKGMapping_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetKGMapping_Response>, I>>(object: I): GetKGMapping_Response {
    const message = createBaseGetKGMapping_Response();
    message.name = object.name ?? undefined;
    message.headers = object.headers?.map((e) => Header.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetScheduledJobRun(): GetScheduledJobRun {
  return {};
}

export const GetScheduledJobRun: MessageFns<GetScheduledJobRun> = {
  encode(_: GetScheduledJobRun, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetScheduledJobRun {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetScheduledJobRun();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetScheduledJobRun {
    return {};
  },

  toJSON(_: GetScheduledJobRun): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetScheduledJobRun>, I>>(base?: I): GetScheduledJobRun {
    return GetScheduledJobRun.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetScheduledJobRun>, I>>(_: I): GetScheduledJobRun {
    const message = createBaseGetScheduledJobRun();
    return message;
  },
};

function createBaseGetScheduledJobRun_Request(): GetScheduledJobRun_Request {
  return {};
}

export const GetScheduledJobRun_Request: MessageFns<GetScheduledJobRun_Request> = {
  encode(_: GetScheduledJobRun_Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetScheduledJobRun_Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetScheduledJobRun_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetScheduledJobRun_Request {
    return {};
  },

  toJSON(_: GetScheduledJobRun_Request): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetScheduledJobRun_Request>, I>>(base?: I): GetScheduledJobRun_Request {
    return GetScheduledJobRun_Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetScheduledJobRun_Request>, I>>(_: I): GetScheduledJobRun_Request {
    const message = createBaseGetScheduledJobRun_Request();
    return message;
  },
};

function createBaseGetScheduledJobRun_Response(): GetScheduledJobRun_Response {
  return { job_run: undefined, job: undefined };
}

export const GetScheduledJobRun_Response: MessageFns<GetScheduledJobRun_Response> = {
  encode(message: GetScheduledJobRun_Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.job_run !== undefined) {
      ScheduledJobRunProto.encode(message.job_run, writer.uint32(10).fork()).join();
    }
    if (message.job !== undefined) {
      ScheduledJobProto.encode(message.job, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetScheduledJobRun_Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetScheduledJobRun_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.job_run = ScheduledJobRunProto.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.job = ScheduledJobProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetScheduledJobRun_Response {
    return {
      job_run: isSet(object.job_run) ? ScheduledJobRunProto.fromJSON(object.job_run) : undefined,
      job: isSet(object.job) ? ScheduledJobProto.fromJSON(object.job) : undefined,
    };
  },

  toJSON(message: GetScheduledJobRun_Response): unknown {
    const obj: any = {};
    if (message.job_run !== undefined) {
      obj.job_run = ScheduledJobRunProto.toJSON(message.job_run);
    }
    if (message.job !== undefined) {
      obj.job = ScheduledJobProto.toJSON(message.job);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetScheduledJobRun_Response>, I>>(base?: I): GetScheduledJobRun_Response {
    return GetScheduledJobRun_Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetScheduledJobRun_Response>, I>>(object: I): GetScheduledJobRun_Response {
    const message = createBaseGetScheduledJobRun_Response();
    message.job_run = (object.job_run !== undefined && object.job_run !== null)
      ? ScheduledJobRunProto.fromPartial(object.job_run)
      : undefined;
    message.job = (object.job !== undefined && object.job !== null)
      ? ScheduledJobProto.fromPartial(object.job)
      : undefined;
    return message;
  },
};

function createBaseAnalystStats(): AnalystStats {
  return {
    num_metrics: undefined,
    num_attributes: undefined,
    num_timeframes: undefined,
    num_benchmarks: undefined,
    num_measures: undefined,
    num_live_jobs: undefined,
    total_jobs: undefined,
  };
}

export const AnalystStats: MessageFns<AnalystStats> = {
  encode(message: AnalystStats, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.num_metrics !== undefined) {
      writer.uint32(8).int32(message.num_metrics);
    }
    if (message.num_attributes !== undefined) {
      writer.uint32(16).int32(message.num_attributes);
    }
    if (message.num_timeframes !== undefined) {
      writer.uint32(24).int32(message.num_timeframes);
    }
    if (message.num_benchmarks !== undefined) {
      writer.uint32(32).int32(message.num_benchmarks);
    }
    if (message.num_measures !== undefined) {
      writer.uint32(40).int32(message.num_measures);
    }
    if (message.num_live_jobs !== undefined) {
      writer.uint32(48).int32(message.num_live_jobs);
    }
    if (message.total_jobs !== undefined) {
      writer.uint32(56).int32(message.total_jobs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalystStats {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalystStats();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.num_metrics = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.num_attributes = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.num_timeframes = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.num_benchmarks = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.num_measures = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.num_live_jobs = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.total_jobs = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalystStats {
    return {
      num_metrics: isSet(object.num_metrics) ? globalThis.Number(object.num_metrics) : undefined,
      num_attributes: isSet(object.num_attributes) ? globalThis.Number(object.num_attributes) : undefined,
      num_timeframes: isSet(object.num_timeframes) ? globalThis.Number(object.num_timeframes) : undefined,
      num_benchmarks: isSet(object.num_benchmarks) ? globalThis.Number(object.num_benchmarks) : undefined,
      num_measures: isSet(object.num_measures) ? globalThis.Number(object.num_measures) : undefined,
      num_live_jobs: isSet(object.num_live_jobs) ? globalThis.Number(object.num_live_jobs) : undefined,
      total_jobs: isSet(object.total_jobs) ? globalThis.Number(object.total_jobs) : undefined,
    };
  },

  toJSON(message: AnalystStats): unknown {
    const obj: any = {};
    if (message.num_metrics !== undefined) {
      obj.num_metrics = Math.round(message.num_metrics);
    }
    if (message.num_attributes !== undefined) {
      obj.num_attributes = Math.round(message.num_attributes);
    }
    if (message.num_timeframes !== undefined) {
      obj.num_timeframes = Math.round(message.num_timeframes);
    }
    if (message.num_benchmarks !== undefined) {
      obj.num_benchmarks = Math.round(message.num_benchmarks);
    }
    if (message.num_measures !== undefined) {
      obj.num_measures = Math.round(message.num_measures);
    }
    if (message.num_live_jobs !== undefined) {
      obj.num_live_jobs = Math.round(message.num_live_jobs);
    }
    if (message.total_jobs !== undefined) {
      obj.total_jobs = Math.round(message.total_jobs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalystStats>, I>>(base?: I): AnalystStats {
    return AnalystStats.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalystStats>, I>>(object: I): AnalystStats {
    const message = createBaseAnalystStats();
    message.num_metrics = object.num_metrics ?? undefined;
    message.num_attributes = object.num_attributes ?? undefined;
    message.num_timeframes = object.num_timeframes ?? undefined;
    message.num_benchmarks = object.num_benchmarks ?? undefined;
    message.num_measures = object.num_measures ?? undefined;
    message.num_live_jobs = object.num_live_jobs ?? undefined;
    message.total_jobs = object.total_jobs ?? undefined;
    return message;
  },
};

function createBaseDataModelStats(): DataModelStats {
  return {
    total_logical_columns: undefined,
    num_mapped_attributes: undefined,
    num_mapped_measures: undefined,
    num_mapped_timeframes: undefined,
    num_mapped_metrics: undefined,
  };
}

export const DataModelStats: MessageFns<DataModelStats> = {
  encode(message: DataModelStats, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.total_logical_columns !== undefined) {
      writer.uint32(8).int32(message.total_logical_columns);
    }
    if (message.num_mapped_attributes !== undefined) {
      writer.uint32(16).int32(message.num_mapped_attributes);
    }
    if (message.num_mapped_measures !== undefined) {
      writer.uint32(24).int32(message.num_mapped_measures);
    }
    if (message.num_mapped_timeframes !== undefined) {
      writer.uint32(32).int32(message.num_mapped_timeframes);
    }
    if (message.num_mapped_metrics !== undefined) {
      writer.uint32(40).int32(message.num_mapped_metrics);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataModelStats {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataModelStats();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.total_logical_columns = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.num_mapped_attributes = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.num_mapped_measures = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.num_mapped_timeframes = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.num_mapped_metrics = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataModelStats {
    return {
      total_logical_columns: isSet(object.total_logical_columns)
        ? globalThis.Number(object.total_logical_columns)
        : undefined,
      num_mapped_attributes: isSet(object.num_mapped_attributes)
        ? globalThis.Number(object.num_mapped_attributes)
        : undefined,
      num_mapped_measures: isSet(object.num_mapped_measures)
        ? globalThis.Number(object.num_mapped_measures)
        : undefined,
      num_mapped_timeframes: isSet(object.num_mapped_timeframes)
        ? globalThis.Number(object.num_mapped_timeframes)
        : undefined,
      num_mapped_metrics: isSet(object.num_mapped_metrics) ? globalThis.Number(object.num_mapped_metrics) : undefined,
    };
  },

  toJSON(message: DataModelStats): unknown {
    const obj: any = {};
    if (message.total_logical_columns !== undefined) {
      obj.total_logical_columns = Math.round(message.total_logical_columns);
    }
    if (message.num_mapped_attributes !== undefined) {
      obj.num_mapped_attributes = Math.round(message.num_mapped_attributes);
    }
    if (message.num_mapped_measures !== undefined) {
      obj.num_mapped_measures = Math.round(message.num_mapped_measures);
    }
    if (message.num_mapped_timeframes !== undefined) {
      obj.num_mapped_timeframes = Math.round(message.num_mapped_timeframes);
    }
    if (message.num_mapped_metrics !== undefined) {
      obj.num_mapped_metrics = Math.round(message.num_mapped_metrics);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataModelStats>, I>>(base?: I): DataModelStats {
    return DataModelStats.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataModelStats>, I>>(object: I): DataModelStats {
    const message = createBaseDataModelStats();
    message.total_logical_columns = object.total_logical_columns ?? undefined;
    message.num_mapped_attributes = object.num_mapped_attributes ?? undefined;
    message.num_mapped_measures = object.num_mapped_measures ?? undefined;
    message.num_mapped_timeframes = object.num_mapped_timeframes ?? undefined;
    message.num_mapped_metrics = object.num_mapped_metrics ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
